unit settings.useraccesssetup;

interface

uses
  System.SysUtils, System.Classes, System.Types, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.DBCtrls, Vcl.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, WEBLib.Grids, WEBLib.DB, Types;

type
  TfrmUserAccessSetup = class(TForm)
    wpMain: TPanel;
    WebScrollBox1: TScrollBox;
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebPanel2: TPanel;
    btnClose: TButton;
    WebPanel3: TPanel;
    WebScrollBox2: TScrollBox;
    WebScrollBox3: TScrollBox;
    grdAccessRights: TDBGrid;
    edtUserCode: TDBEdit;
    edtUserName: TDBEdit;
    edtPassword: TDBEdit;
    btnGenPassword: TButton;
    webclient: TXDataWebClient;
    qAccess: TXDataWebDataSet;
    qAccessMainCat: TStringField;
    qAccessSubCat: TStringField;
    qAccessData: TBooleanField;
    qUser: TXDataWebDataSet;
    grdMain: TStringGrid;
    dsUser: TDataSource;
    dsAccess: TDataSource;
    qAccessAutoNo: TIntegerField;
    btnCopyRights: TButton;
    edtCellNo: TDBEdit;
    edtEmail: TDBEdit;
    WebDBCheckBox1: TDBCheckBox;
    wdblSites: TDBLookupComboBox;
    WebDBCheckBox2: TDBCheckBox;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    btnCancel: TButton;
    btnSave: TButton;
    WebMessageDlg1: TMessageDlg;
    qSites: TXDataWebDataSet;
    dsSites: TDataSource;
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure qUserAfterOpen(DataSet: TDataSet);
    procedure qAccessAfterOpen(DataSet: TDataSet);
    procedure btnCancelClick(Sender: TObject);
    procedure grdMainClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure grdAccessRightsCanEditCell(Sender: TObject; ACol, ARow: Integer;
      var CanEdit: Boolean);
    procedure grdAccessRightsClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure btnSaveClick(Sender: TObject);
    procedure btnGenPasswordClick(Sender: TObject);
    procedure btnCopyRightsClick(Sender: TObject);
  private
    { Private declarations }
    procedure DoPostData;
  public
    { Public declarations }
    sUser : String;
    bAppend, bExistingUser : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  frmUserAccessSetup: TfrmUserAccessSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, settings.usercopyrights, share.common;

procedure TfrmUserAccessSetup.DoPostData;
  procedure OnError(Error: TXDataClientError);
  begin
   WebMessageDlg1.ShowDialog('An Error was encountered while Saving the Access Rights.' + sLineBreak +
                             Error.ErrorMessage, mtError, [mbOk]);
   //Abort;
  end;
begin
 try
   qUser.Post;
   qUser.ApplyUpdates;
 except
   on Error : Exception do
     begin
       WebMessageDlg1.ShowDialog('An Error was encountered while Saving the User Details.' + sLineBreak +
                                  Error.Message, mtError, [mbOk]);
       //Abort;
     end;
 end;
 try
   webclient.RawInvoke('IstfmsSystemService.PutUserAccess', [Trim(edtUserCode.Text), qAccess.CurrentData], nil, @OnError);
 except
   on Error : Exception do
     begin
       WebMessageDlg1.ShowDialog('An Error was encountered while Saving the Access Rights.' + #13#10 +
                                  Error.Message, mtError, [mbOk]);
       Exit; //Abort;
     end;
 end;
 ShowMessage('Post SuccessFull!!!');
end;

procedure TfrmUserAccessSetup.qAccessAfterOpen(DataSet: TDataSet);
  var sList : TStringList;
      sCat : String;
      iCntr : Integer;
begin
  if qAccess.RecordCount > 0 then
   begin
    sList := TStringList.Create;
    sList.Sorted := True;
    sList.Duplicates := dupIgnore;
    qAccess.First;
    while not qAccess.Eof do
     begin
      sCat := qAccess.FieldByName('MainCat').AsString;
      sList.Add(sCat);
      qAccess.Next;
     end;
    grdMain.Cells[0,0] := 'Main Category';
    grdMain.RowCount := 1;
    for iCntr := 0 to sList.Count - 1 do
     begin
      sCat := sList[iCntr];
      grdMain.RowCount := iCntr + 2;
      grdMain.Cells[0,iCntr + 1] := sCat;
     end;
    grdMain.Row := 1;
    sList.Clear;
    sList.Free;
   end;
end;

procedure TfrmUserAccessSetup.qUserAfterOpen(DataSet: TDataSet);
begin
  if bAppend then
    qUser.Append
  else
    qUser.Edit;
end;

procedure TfrmUserAccessSetup.grdMainClickCell(Sender: TObject; ACol,
  ARow: Integer);
  var sCat : String;
begin
  if ARow = 0
   then Exit;

  sCat := grdMain.Cells[0,ARow];
  qAccess.Filtered := False;
  qAccess.Filter := 'MainCat = ' + QuotedStr(sCat);
  qAccess.Filtered := True;
  {qAccess.Close;
  qAccess.QueryString := '$filter=MainCat eq ' + QuotedStr(sCat);
  qAccess.Load;}
end;

procedure TfrmUserAccessSetup.btnCloseClick(Sender: TObject);
begin
 Close;
end;

procedure TfrmUserAccessSetup.btnGenPasswordClick(Sender: TObject);
begin
 edtPassword.Text := GeneratePassword(10, [pmLower, pmUpper, pmNumbers, pmExtra]);
end;

procedure TfrmUserAccessSetup.btnCancelClick(Sender: TObject);
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qAccess.Close;
    qAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qAccess.Open;
  end;
begin
 if qUser.State in [dsEdit]
  then qUser.Cancel;
 webclient.RawInvoke('IstfmsSystemService.GetUserAccess', [sUser], @OnResult);
end;

procedure TfrmUserAccessSetup.btnSaveClick(Sender: TObject);
  var
    q : TXDataWebDataSet;
  procedure AfterOpen(DataSet: TDataSet);
  begin
    bExistingUser := not q.IsEmpty;
    q.Free;
    if bExistingUser then
      begin
        WebMessageDlg1.ShowDialog('User Code Already Exists', mtError, [mbOk]);
        edtUserCode.Setfocus;
        Exit;
      end;
    DoPostData;
  end;
begin
  if edtUserName.Text = '' then
   begin
    WebMessageDlg1.ShowDialog('User Name must have A Value', mtError, [mbOk]);
    edtUserName.Setfocus;
    Exit;
   end;
  if edtEmail.Text = '' then
   begin
    WebMessageDlg1.ShowDialog('E-Mail Address must have A Value', mtError, [mbOk]);
    edtEmail.Setfocus;
    Exit;
   end;
  if qUser.State in [dsInsert] then
   begin
    if Trim(edtUserCode.Text) = '' then
      begin
        WebMessageDlg1.ShowDialog('User Code must have A Value', mtError, [mbOk]);
        edtUserCode.Setfocus;
        exit;
      end;
    //ValidateUserCode;
    q := TXDataWebDataSet.Create(nil);
    q.Connection := dmdata.dbConnect;
    q.EntitySetName := 'workemail';
    q.QueryString := '$filter=slncode eq' + QuotedStr(Trim(edtUserCode.Text));
    q.AfterOpen := AfterOpen;
    q.Load;
   end
  else
   begin
    DoPostData;
    ShowMessage('Post SuccessFull!');
   end;
end;

procedure TfrmUserAccessSetup.grdAccessRightsCanEditCell(Sender: TObject; ACol,
  ARow: Integer; var CanEdit: Boolean);
begin
 CanEdit := False;
 if ARow >= 1 then
  begin
   if ACol = 1
    then CanEdit := True;
  end;
end;

procedure TfrmUserAccessSetup.grdAccessRightsClickCell(Sender: TObject; ACol,
  ARow: Integer);
begin
  if Acol = 2 then
    begin
      {qAccess.First;
      qAccess.MoveBy(ARow - 1); }
      qAccess.Edit;
      qAccess.FieldByName('Data').AsBoolean := not qAccess.FieldByName('Data').AsBoolean;
      {if qAccess.FieldByName('Data').AsBoolean then
        qAccess.FieldByName('Data').AsBoolean := False
      else
        qAccess.FieldByName('Data').AsBoolean := True;    }
      qAccess.Post;
    end;
end;

procedure TfrmUserAccessSetup.btnCopyRightsClick(Sender: TObject);
var
  LFrm : TfrmUserCopyRights;
  procedure AfterCreate(AForm : TObject);
   begin
    with (AForm as TfrmUserCopyRights) do
     begin
      sUser := qUser.FieldByName('slncode').asString;
      //qUsers.Close;
      {qUsers.QueryString := '$filter=slncode ne ' + quotedstr(sUser) + ' & ' +
                            'suspended eq ''N'' & order SLNNAME';   }
      qUsers.Load;
      btnCopySelected := False;
     end;
    end;
  procedure AfterShoWModal(AValue: TModalResult);
   begin
    qUser.Close;
    qUser.Load;
   end;
begin
 LFrm :=  TfrmUserCopyRights.CreateNew(@AfterCreate);
 // LFrm als Pop-Up festlegen
 LFrm.Popup := true;

 // Transparenz definieren
 LFrm.PopupOpacity := 0.2;
 LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmUserAccessSetup.WebFormShow(Sender: TObject);
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qAccess.Close;
    qAccess.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qAccess.Open;
  end;
begin
  webclient.RawInvoke('IstfmsSystemService.GetUserAccess', [sUser], @OnResult);
  qUser.Close;
  qUser.QueryString := '$filter=slncode eq ' + quotedstr(sUser);
  qUser.Load;
  qSites.Close;
  qSites.Load;
  bExistingUser := False;
  edtUserCode.ReadOnly := not bAppend;
  wdblSites.Height := edtEmail.Height;
  btnGenPassword.Top := edtPassword.Top;
  btnGenPassword.Height := edtPassword.Height;
end;

procedure TfrmUserAccessSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpMain := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  edtUserCode := TDBEdit.Create(Self);
  edtUserName := TDBEdit.Create(Self);
  edtPassword := TDBEdit.Create(Self);
  btnGenPassword := TButton.Create(Self);
  btnCopyRights := TButton.Create(Self);
  edtCellNo := TDBEdit.Create(Self);
  edtEmail := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  wdblSites := TDBLookupComboBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  WebScrollBox2 := TScrollBox.Create(Self);
  grdMain := TStringGrid.Create(Self);
  WebScrollBox3 := TScrollBox.Create(Self);
  grdAccessRights := TDBGrid.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  btnClose := TButton.Create(Self);
  btnCancel := TButton.Create(Self);
  btnSave := TButton.Create(Self);
  webclient := TXDataWebClient.Create(Self);
  qAccess := TXDataWebDataSet.Create(Self);
  qAccessAutoNo := TIntegerField.Create(Self);
  qAccessMainCat := TStringField.Create(Self);
  qAccessSubCat := TStringField.Create(Self);
  qAccessData := TBooleanField.Create(Self);
  qUser := TXDataWebDataSet.Create(Self);
  dsUser := TDataSource.Create(Self);
  dsAccess := TDataSource.Create(Self);
  qSites := TXDataWebDataSet.Create(Self);
  dsSites := TDataSource.Create(Self);

  wpMain.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  edtUserCode.BeforeLoadDFMValues;
  edtUserName.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  btnGenPassword.BeforeLoadDFMValues;
  btnCopyRights.BeforeLoadDFMValues;
  edtCellNo.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  wdblSites.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  WebScrollBox2.BeforeLoadDFMValues;
  grdMain.BeforeLoadDFMValues;
  WebScrollBox3.BeforeLoadDFMValues;
  grdAccessRights.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  webclient.BeforeLoadDFMValues;
  qAccess.BeforeLoadDFMValues;
  qAccessAutoNo.BeforeLoadDFMValues;
  qAccessMainCat.BeforeLoadDFMValues;
  qAccessSubCat.BeforeLoadDFMValues;
  qAccessData.BeforeLoadDFMValues;
  qUser.BeforeLoadDFMValues;
  dsUser.BeforeLoadDFMValues;
  dsAccess.BeforeLoadDFMValues;
  qSites.BeforeLoadDFMValues;
  dsSites.BeforeLoadDFMValues;
  try
    Name := 'frmUserAccessSetup';
    Width := 836;
    Height := 484;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 836;
    wpMain.Height := 484;
    wpMain.ElementClassName := 'card';
    wpMain.Align := alClient;
    wpMain.ElementBodyClassName := 'card-body';
    wpMain.ElementFont := efCSS;
    WebScrollBox1.SetParentComponent(wpMain);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 33;
    WebScrollBox1.Width := 836;
    WebScrollBox1.Height := 386;
    WebScrollBox1.ElementClassName := 'card';
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 2;
    WebPanel3.SetParentComponent(WebScrollBox1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 836;
    WebPanel3.Height := 217;
    WebPanel3.ElementClassName := 'card';
    WebPanel3.Align := alTop;
    WebPanel3.ElementBodyClassName := 'card-body';
    WebPanel3.ElementFont := efCSS;
    WebLabel3.SetParentComponent(WebPanel3);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 3;
    WebLabel3.Top := 6;
    WebLabel3.Width := 59;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'User Code';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -13;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel3);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 130;
    WebLabel4.Top := 6;
    WebLabel4.Width := 63;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'User Name';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -13;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel3);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 503;
    WebLabel5.Top := 6;
    WebLabel5.Width := 55;
    WebLabel5.Height := 16;
    WebLabel5.Caption := 'Password';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -13;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel3);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 3;
    WebLabel6.Top := 79;
    WebLabel6.Width := 70;
    WebLabel6.Height := 16;
    WebLabel6.Caption := 'Cell Number';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -13;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel3);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 130;
    WebLabel7.Top := 79;
    WebLabel7.Width := 35;
    WebLabel7.Height := 16;
    WebLabel7.Caption := 'E-Mail';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -13;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel3);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 503;
    WebLabel8.Top := 79;
    WebLabel8.Width := 22;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Site';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -13;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    edtUserCode.SetParentComponent(WebPanel3);
    edtUserCode.Name := 'edtUserCode';
    edtUserCode.Left := 3;
    edtUserCode.Top := 29;
    edtUserCode.Width := 121;
    edtUserCode.Height := 22;
    edtUserCode.CharCase := wecUpperCase;
    edtUserCode.Font.Charset := DEFAULT_CHARSET;
    edtUserCode.Font.Color := clWindowText;
    edtUserCode.Font.Height := -13;
    edtUserCode.Font.Name := 'Tahoma';
    edtUserCode.Font.Style := [];
    edtUserCode.HeightStyle := ssAuto;
    edtUserCode.HeightPercent := 100.000000000000000000;
    edtUserCode.MaxLength := 10;
    edtUserCode.ParentFont := False;
    edtUserCode.Text := 'edtUserCode';
    edtUserCode.WidthPercent := 100.000000000000000000;
    edtUserCode.DataField := 'SLNCODE';
    edtUserCode.DataSource := dsUser;
    edtUserName.SetParentComponent(WebPanel3);
    edtUserName.Name := 'edtUserName';
    edtUserName.Left := 130;
    edtUserName.Top := 29;
    edtUserName.Width := 367;
    edtUserName.Height := 22;
    edtUserName.ChildOrder := 2;
    edtUserName.Font.Charset := DEFAULT_CHARSET;
    edtUserName.Font.Color := clWindowText;
    edtUserName.Font.Height := -13;
    edtUserName.Font.Name := 'Tahoma';
    edtUserName.Font.Style := [];
    edtUserName.HeightStyle := ssAuto;
    edtUserName.HeightPercent := 100.000000000000000000;
    edtUserName.MaxLength := 10;
    edtUserName.ParentFont := False;
    edtUserName.Text := 'WebDBEdit1';
    edtUserName.WidthPercent := 100.000000000000000000;
    edtUserName.DataField := 'SLNNAME';
    edtUserName.DataSource := dsUser;
    edtPassword.SetParentComponent(WebPanel3);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 503;
    edtPassword.Top := 29;
    edtPassword.Width := 121;
    edtPassword.Height := 22;
    edtPassword.ChildOrder := 5;
    edtPassword.Font.Charset := DEFAULT_CHARSET;
    edtPassword.Font.Color := clWindowText;
    edtPassword.Font.Height := -13;
    edtPassword.Font.Name := 'Tahoma';
    edtPassword.Font.Style := [];
    edtPassword.HeightStyle := ssAuto;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.MaxLength := 10;
    edtPassword.ParentFont := False;
    edtPassword.Text := 'WebDBEdit1';
    edtPassword.WidthPercent := 100.000000000000000000;
    edtPassword.DataField := 'PASSWORD';
    edtPassword.DataSource := dsUser;
    btnGenPassword.SetParentComponent(WebPanel3);
    btnGenPassword.Name := 'btnGenPassword';
    btnGenPassword.Left := 630;
    btnGenPassword.Top := 29;
    btnGenPassword.Width := 91;
    btnGenPassword.Height := 25;
    btnGenPassword.Caption := 'Generate';
    btnGenPassword.Color := 11186720;
    btnGenPassword.ChildOrder := 6;
    btnGenPassword.Font.Charset := DEFAULT_CHARSET;
    btnGenPassword.Font.Color := clWhite;
    btnGenPassword.Font.Height := -13;
    btnGenPassword.Font.Name := 'Tahoma';
    btnGenPassword.Font.Style := [];
    btnGenPassword.HeightStyle := ssAuto;
    btnGenPassword.HeightPercent := 100.000000000000000000;
    btnGenPassword.ParentFont := False;
    btnGenPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnGenPassword, Self, 'OnClick', 'btnGenPasswordClick');
    btnCopyRights.SetParentComponent(WebPanel3);
    btnCopyRights.Name := 'btnCopyRights';
    btnCopyRights.Left := 503;
    btnCopyRights.Top := 138;
    btnCopyRights.Width := 156;
    btnCopyRights.Height := 25;
    btnCopyRights.Caption := 'Copy Access Rights';
    btnCopyRights.Color := 11186720;
    btnCopyRights.ChildOrder := 6;
    btnCopyRights.Font.Charset := DEFAULT_CHARSET;
    btnCopyRights.Font.Color := clWhite;
    btnCopyRights.Font.Height := -13;
    btnCopyRights.Font.Name := 'Tahoma';
    btnCopyRights.Font.Style := [];
    btnCopyRights.HeightStyle := ssAuto;
    btnCopyRights.HeightPercent := 100.000000000000000000;
    btnCopyRights.ParentFont := False;
    btnCopyRights.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopyRights, Self, 'OnClick', 'btnCopyRightsClick');
    edtCellNo.SetParentComponent(WebPanel3);
    edtCellNo.Name := 'edtCellNo';
    edtCellNo.Left := 3;
    edtCellNo.Top := 101;
    edtCellNo.Width := 121;
    edtCellNo.Height := 22;
    edtCellNo.ChildOrder := 8;
    edtCellNo.Font.Charset := DEFAULT_CHARSET;
    edtCellNo.Font.Color := clWindowText;
    edtCellNo.Font.Height := -13;
    edtCellNo.Font.Name := 'Tahoma';
    edtCellNo.Font.Style := [];
    edtCellNo.HeightStyle := ssAuto;
    edtCellNo.HeightPercent := 100.000000000000000000;
    edtCellNo.MaxLength := 10;
    edtCellNo.ParentFont := False;
    edtCellNo.Text := 'WebDBEdit1';
    edtCellNo.WidthPercent := 100.000000000000000000;
    edtCellNo.DataField := 'cellnumber';
    edtCellNo.DataSource := dsUser;
    edtEmail.SetParentComponent(WebPanel3);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 130;
    edtEmail.Top := 101;
    edtEmail.Width := 367;
    edtEmail.Height := 22;
    edtEmail.ChildOrder := 2;
    edtEmail.Font.Charset := DEFAULT_CHARSET;
    edtEmail.Font.Color := clWindowText;
    edtEmail.Font.Height := -13;
    edtEmail.Font.Name := 'Tahoma';
    edtEmail.Font.Style := [];
    edtEmail.HeightStyle := ssAuto;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.MaxLength := 10;
    edtEmail.ParentFont := False;
    edtEmail.Text := 'WebDBEdit1';
    edtEmail.WidthPercent := 100.000000000000000000;
    edtEmail.DataField := 'EMAIL';
    edtEmail.DataSource := dsUser;
    WebDBCheckBox1.SetParentComponent(WebPanel3);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 40;
    WebDBCheckBox1.Top := 139;
    WebDBCheckBox1.Width := 281;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'Send Diesel Supplier Balance';
    WebDBCheckBox1.ChildOrder := 12;
    WebDBCheckBox1.Font.Charset := DEFAULT_CHARSET;
    WebDBCheckBox1.Font.Color := clWindowText;
    WebDBCheckBox1.Font.Height := -13;
    WebDBCheckBox1.Font.Name := 'Tahoma';
    WebDBCheckBox1.Font.Style := [];
    WebDBCheckBox1.HeightStyle := ssAuto;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.ParentFont := False;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'smsdieselerrors';
    WebDBCheckBox1.DataSource := dsUser;
    WebDBCheckBox1.ValueChecked := 'Y';
    WebDBCheckBox1.ValueUnChecked := 'N';
    wdblSites.SetParentComponent(WebPanel3);
    wdblSites.Name := 'wdblSites';
    wdblSites.Left := 503;
    wdblSites.Top := 101;
    wdblSites.Width := 315;
    wdblSites.Height := 22;
    wdblSites.Font.Charset := DEFAULT_CHARSET;
    wdblSites.Font.Color := clWindowText;
    wdblSites.Font.Height := -13;
    wdblSites.Font.Name := 'Tahoma';
    wdblSites.Font.Style := [];
    wdblSites.HeightPercent := 100.000000000000000000;
    wdblSites.ParentFont := False;
    wdblSites.WidthPercent := 100.000000000000000000;
    wdblSites.DataField := 'SITES';
    wdblSites.DataSource := dsUser;
    wdblSites.KeyField := 'CODE';
    wdblSites.ListField := 'DESCRIPTION';
    wdblSites.ListSource := dsSites;
    WebDBCheckBox2.SetParentComponent(WebPanel3);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 388;
    WebDBCheckBox2.Top := 139;
    WebDBCheckBox2.Width := 109;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Caption := 'Suspend';
    WebDBCheckBox2.ChildOrder := 12;
    WebDBCheckBox2.ElementLabelClassName := 'custom-control-label';
    WebDBCheckBox2.Font.Charset := DEFAULT_CHARSET;
    WebDBCheckBox2.Font.Color := clWindowText;
    WebDBCheckBox2.Font.Height := -13;
    WebDBCheckBox2.Font.Name := 'Tahoma';
    WebDBCheckBox2.Font.Style := [];
    WebDBCheckBox2.HeightStyle := ssAuto;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.ParentFont := False;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox2.DataField := 'suspended';
    WebDBCheckBox2.DataSource := dsUser;
    WebDBCheckBox2.ValueChecked := 'Y';
    WebDBCheckBox2.ValueUnChecked := 'N';
    WebMessageDlg1.SetParentComponent(WebPanel3);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 720;
    WebMessageDlg1.Top := 139;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebMessageDlg1.ElementButtonClassName := 'btn';
    WebMessageDlg1.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg1.ElementTitleClassName := 'text-body';
    WebMessageDlg1.ElementContentClassName := 'text-body';
    WebScrollBox2.SetParentComponent(WebScrollBox1);
    WebScrollBox2.Name := 'WebScrollBox2';
    WebScrollBox2.Left := 0;
    WebScrollBox2.Top := 217;
    WebScrollBox2.Width := 281;
    WebScrollBox2.Height := 169;
    WebScrollBox2.ElementClassName := 'card';
    WebScrollBox2.Align := alLeft;
    WebScrollBox2.BorderStyle := bsSingle;
    WebScrollBox2.ChildOrder := 1;
    grdMain.SetParentComponent(WebScrollBox2);
    grdMain.Name := 'grdMain';
    grdMain.Left := 0;
    grdMain.Top := 0;
    grdMain.Width := 281;
    grdMain.Height := 169;
    grdMain.Align := alClient;
    grdMain.ColCount := 1;
    grdMain.FixedCols := 0;
    grdMain.Font.Charset := DEFAULT_CHARSET;
    grdMain.Font.Color := clWindowText;
    grdMain.Font.Height := -13;
    grdMain.Font.Name := 'Tahoma';
    grdMain.Font.Style := [];
    grdMain.ParentFont := False;
    grdMain.TabOrder := 0;
    grdMain.RangeEdit.Max := 100.000000000000000000;
    grdMain.RangeEdit.Step := 1.000000000000000000;
    grdMain.HeightPercent := 100.000000000000000000;
    grdMain.WidthPercent := 100.000000000000000000;
    SetEvent(grdMain, Self, 'OnClickCell', 'grdMainClickCell');
    grdMain.ColWidths[0] := 254;
    WebScrollBox3.SetParentComponent(WebScrollBox1);
    WebScrollBox3.Name := 'WebScrollBox3';
    WebScrollBox3.Left := 281;
    WebScrollBox3.Top := 217;
    WebScrollBox3.Width := 555;
    WebScrollBox3.Height := 169;
    WebScrollBox3.ElementClassName := 'card';
    WebScrollBox3.Align := alClient;
    WebScrollBox3.BorderStyle := bsSingle;
    WebScrollBox3.ChildOrder := 1;
    grdAccessRights.SetParentComponent(WebScrollBox3);
    grdAccessRights.Name := 'grdAccessRights';
    grdAccessRights.Left := 0;
    grdAccessRights.Top := 0;
    grdAccessRights.Width := 555;
    grdAccessRights.Height := 169;
    grdAccessRights.Align := alClient;
    grdAccessRights.Columns.Clear;
    with grdAccessRights.Columns.Add do
    begin
      DataField := 'SubCat';
      Title := 'Access Name';
      Width := 311;
    end;
    with grdAccessRights.Columns.Add do
    begin
      DataField := 'Data';
      DataType := cdCheck;
      Title := 'Access';
    end;
    grdAccessRights.DataSource := dsAccess;
    grdAccessRights.FixedCols := 1;
    grdAccessRights.Font.Charset := DEFAULT_CHARSET;
    grdAccessRights.Font.Color := clWindowText;
    grdAccessRights.Font.Height := -13;
    grdAccessRights.Font.Name := 'Tahoma';
    grdAccessRights.Font.Style := [];
    grdAccessRights.ParentFont := False;
    grdAccessRights.TabOrder := 0;
    grdAccessRights.HeightPercent := 100.000000000000000000;
    grdAccessRights.WidthPercent := 100.000000000000000000;
    SetEvent(grdAccessRights, Self, 'OnCanEditCell', 'grdAccessRightsCanEditCell');
    SetEvent(grdAccessRights, Self, 'OnClickCell', 'grdAccessRightsClickCell');
    grdAccessRights.ColWidths[0] := 24;
    grdAccessRights.ColWidths[1] := 311;
    grdAccessRights.ColWidths[2] := 64;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 836;
    WebPanel1.Height := 33;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.Align := alTop;
    WebPanel1.BorderStyle := bsNone;
    WebPanel1.ChildOrder := 1;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -13;
    WebPanel1.Font.Name := 'Tahoma';
    WebPanel1.Font.Style := [];
    WebPanel1.ParentFont := False;
    WebPanel1.ShowCaption := False;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 836;
    WebLabel1.Height := 33;
    WebLabel1.Align := alClient;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'User Setup';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(wpMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 419;
    WebPanel2.Width := 836;
    WebPanel2.Height := 65;
    WebPanel2.ElementClassName := 'card';
    WebPanel2.Align := alBottom;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.ShowCaption := False;
    btnClose.SetParentComponent(WebPanel2);
    btnClose.Name := 'btnClose';
    btnClose.Left := 693;
    btnClose.Top := 6;
    btnClose.Width := 139;
    btnClose.Height := 49;
    btnClose.Caption := 'Close';
    btnClose.Color := 3937500;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWhite;
    btnClose.Font.Height := -13;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnCancel.SetParentComponent(WebPanel2);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 503;
    btnCancel.Top := 6;
    btnCancel.Width := 139;
    btnCancel.Height := 49;
    btnCancel.Caption := 'Cancel ';
    btnCancel.Color := 55295;
    btnCancel.ChildOrder := 1;
    btnCancel.Font.Charset := DEFAULT_CHARSET;
    btnCancel.Font.Color := clWindowText;
    btnCancel.Font.Height := -13;
    btnCancel.Font.Name := 'Tahoma';
    btnCancel.Font.Style := [];
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.ParentFont := False;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnSave.SetParentComponent(WebPanel2);
    btnSave.Name := 'btnSave';
    btnSave.Left := 343;
    btnSave.Top := 6;
    btnSave.Width := 139;
    btnSave.Height := 49;
    btnSave.Caption := 'Save';
    btnSave.Color := clGreen;
    btnSave.ChildOrder := 1;
    btnSave.Font.Charset := DEFAULT_CHARSET;
    btnSave.Font.Color := clWhite;
    btnSave.Font.Height := -13;
    btnSave.Font.Name := 'Tahoma';
    btnSave.Font.Style := [];
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.ParentFont := False;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    webclient.SetParentComponent(Self);
    webclient.Name := 'webclient';
    webclient.Connection := dmData.dbConnect;
    webclient.Left := 720;
    webclient.Top := 258;
    qAccess.SetParentComponent(Self);
    qAccess.Name := 'qAccess';
    qAccess.AfterOpen := qAccessAfterOpen;
    qAccess.Connection := dmData.dbConnect;
    qAccess.Left := 424;
    qAccess.Top := 258;
    qAccessAutoNo.SetParentComponent(qAccess);
    qAccessAutoNo.Name := 'qAccessAutoNo';
    qAccessAutoNo.FieldName := 'AutoNo';
    qAccessMainCat.SetParentComponent(qAccess);
    qAccessMainCat.Name := 'qAccessMainCat';
    qAccessMainCat.FieldName := 'MainCat';
    qAccessSubCat.SetParentComponent(qAccess);
    qAccessSubCat.Name := 'qAccessSubCat';
    qAccessSubCat.FieldName := 'SubCat';
    qAccessData.SetParentComponent(qAccess);
    qAccessData.Name := 'qAccessData';
    qAccessData.Alignment := taCenter;
    qAccessData.FieldName := 'Data';
    qUser.SetParentComponent(Self);
    qUser.Name := 'qUser';
    qUser.AfterOpen := qUserAfterOpen;
    qUser.EntitySetName := 'workemail';
    qUser.Connection := dmData.dbConnect;
    qUser.Left := 88;
    qUser.Top := 241;
    dsUser.SetParentComponent(Self);
    dsUser.Name := 'dsUser';
    dsUser.DataSet := qUser;
    dsUser.Left := 160;
    dsUser.Top := 241;
    dsAccess.SetParentComponent(Self);
    dsAccess.Name := 'dsAccess';
    dsAccess.DataSet := qAccess;
    dsAccess.Left := 488;
    dsAccess.Top := 257;
    qSites.SetParentComponent(Self);
    qSites.Name := 'qSites';
    qSites.EntitySetName := 'sites';
    qSites.Connection := dmData.dbConnect;
    qSites.QueryString := '$filter=suspended eq '#39'N'#39' & order DESCRIPTION';
    qSites.Left := 609;
    qSites.Top := 89;
    dsSites.SetParentComponent(Self);
    dsSites.Name := 'dsSites';
    dsSites.AutoEdit := False;
    dsSites.DataSet := qSites;
    dsSites.Left := 689;
    dsSites.Top := 90;
  finally
    wpMain.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    edtUserCode.AfterLoadDFMValues;
    edtUserName.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    btnGenPassword.AfterLoadDFMValues;
    btnCopyRights.AfterLoadDFMValues;
    edtCellNo.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    wdblSites.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    WebScrollBox2.AfterLoadDFMValues;
    grdMain.AfterLoadDFMValues;
    WebScrollBox3.AfterLoadDFMValues;
    grdAccessRights.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    webclient.AfterLoadDFMValues;
    qAccess.AfterLoadDFMValues;
    qAccessAutoNo.AfterLoadDFMValues;
    qAccessMainCat.AfterLoadDFMValues;
    qAccessSubCat.AfterLoadDFMValues;
    qAccessData.AfterLoadDFMValues;
    qUser.AfterLoadDFMValues;
    dsUser.AfterLoadDFMValues;
    dsAccess.AfterLoadDFMValues;
    qSites.AfterLoadDFMValues;
    dsSites.AfterLoadDFMValues;
  end;
end;

end.